// removed by extract-text-webpack-plugin
module.exports = {"RestaurantName":"BookingPolicies__RestaurantName__2LJsH","RestaurantDescription":"BookingPolicies__RestaurantDescription__b1K71","Image":"BookingPolicies__Image__vwrpz","PrivacyPolicyLink":"BookingPolicies__PrivacyPolicyLink__3MrDN","ModalContentContainer":"BookingPolicies__ModalContentContainer__2PG1N","ModalTitle":"BookingPolicies__ModalTitle__319Nd","ModalText":"BookingPolicies__ModalText__1S4lm","ModalSeparator":"BookingPolicies__ModalSeparator__1P4Dq","PhoneLink":"BookingPolicies__PhoneLink__1sLBr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/bookingPolicies/BookingPolicies.css
// module id = 124
// module chunks = 0